module.exports = __webpack_public_path__ + "files/3bf540907b438d9ad338aa4ffa12443b.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/code_themes/monokai.png
// module id = 832
// module chunks = 60